/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  CarrierCreditNote,
  CarrierInvoice,
  CarrierInvoiceApprovalType,
  CarrierInvoiceData,
  CarrierPaymentProperties,
  CarrierRequestAudit,
  CurrencyCode,
  EmailDescription,
  InvoiceChallengeType,
  MissingInvoicesScreenRecords,
} from "../models/index";
import {
  CarrierCreditNoteFromJSON,
  CarrierCreditNoteToJSON,
  CarrierInvoiceFromJSON,
  CarrierInvoiceToJSON,
  CarrierInvoiceApprovalTypeFromJSON,
  CarrierInvoiceApprovalTypeToJSON,
  CarrierInvoiceDataFromJSON,
  CarrierInvoiceDataToJSON,
  CarrierPaymentPropertiesFromJSON,
  CarrierPaymentPropertiesToJSON,
  CarrierRequestAuditFromJSON,
  CarrierRequestAuditToJSON,
  CurrencyCodeFromJSON,
  CurrencyCodeToJSON,
  EmailDescriptionFromJSON,
  EmailDescriptionToJSON,
  InvoiceChallengeTypeFromJSON,
  InvoiceChallengeTypeToJSON,
  MissingInvoicesScreenRecordsFromJSON,
  MissingInvoicesScreenRecordsToJSON,
} from "../models/index";

export interface AddCarrierInvoiceRequest {
  shipmentId: string;
  carrierIdentifier: string;
  invoiceIdentifier: string;
  carrierAccountNumber: string;
  amount: number;
  currency: CurrencyCode;
  isAdditional: boolean;
  body: string;
}

export interface CheckIfCarrierCreditNoteIsPaidRequest {
  carrierCreditNoteId: string;
}

export interface CheckIfCarrierInvoiceIsPaidRequest {
  carrierInvoiceId: string;
}

export interface ClearChequeSendAttemptedRequest {
  carrierInvoiceId: string;
}

export interface CreateCarrierCreditNoteRequest {
  carrierInvoiceId: string;
  amount: number;
  currency: CurrencyCode;
}

export interface CreateMissingInvoiceMondayAndEmailCarrierRequest {
  shipmentId: string;
}

export interface CreateProvisionalInvoiceRequest {
  shipmentId: string;
}

export interface CreateXeroCarrierInvoiceRequest {
  carrierInvoiceId: string;
}

export interface GetCarrierInvoiceByChequeNumberRequest {
  chequeNumber: string;
}

export interface GetCarrierRequestAuditForQuoteRequest {
  shipmentId: string;
  quoteId: string;
}

export interface GetCarrierRequestAuditForSelectedQuoteRequest {
  shipmentId: string;
}

export interface GetPaymentPropertiesRequest {
  carrierInvoiceId: string;
}

export interface MarkCarrierCreditNoteRefundRequestedRequest {
  carrierCreditNoteId: string;
  refundRequested: boolean;
}

export interface MarkCarrierInvoiceApprovedRequest {
  carrierInvoiceId: string;
  approvalReason: string;
  cancelledShipmentApprovalReason?: string | null;
}

export interface MarkCarrierInvoicePaymentPendingRequest {
  carrierInvoiceId: string;
}

export interface MarkCarrierInvoiceProblemsIdentifiedRequest {
  carrierInvoiceId: string;
  problemsIdentified: boolean;
}

export interface MarkCarrierInvoiceVoidedRequest {
  carrierInvoiceId: string;
  voidReason: string;
}

export interface MarkPaymentConfirmedCarrierInvoiceVoidedRequest {
  carrierInvoiceId: string;
  reason: string;
}

export interface MarkPaymentPendingCarrierInvoiceApprovedRequest {
  carrierInvoiceId: string;
  reason: string;
}

export interface PayCarrierInvoiceByChequeRequest {
  carrierInvoiceId: string;
}

export interface PreviewEmailForCarrierInvoiceRequest {
  carrierInvoiceId: string;
  invoiceChallengeType: InvoiceChallengeType;
  extraText: string;
}

export interface PreviewEmailForOverchargeClaimRequest {
  carrierCreditNoteId: string;
  extraText: string;
}

export interface RequestPayCarrierInvoiceRequest {
  carrierInvoiceId: string;
}

export interface SendEmailAskingToChargeCardOnFileForCarrierInvoiceRequest {
  carrierInvoiceId: string;
}

export interface SendOverchargeClaimEmailRequest {
  carrierCreditNoteId: string;
  extraText: string;
  toAddresses?: Array<string> | null;
  ccEmail?: Array<string> | null;
}

export interface SetCarrierXeroInvoiceIdRequest {
  carrierInvoiceId: string;
  xeroInvoiceId: string;
}

export interface UpdateCarrierInvoiceCarrierAccountNumberRequest {
  carrierInvoiceId: string;
  carrierAccountNumber: string;
}

export interface UpdateCarrierInvoiceInvoiceIdentifierRequest {
  carrierInvoiceId: string;
  invoiceIdentifier: string;
}

export interface VoidCarrierCreditNoteRequest {
  carrierCreditNoteId: string;
}

/**
 *
 */
export class CarrierInvoiceApi extends runtime.BaseAPI {
  /**
   */
  async addCarrierInvoiceRaw(
    requestParameters: AddCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierInvoiceApprovalType>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["invoiceIdentifier"] == null) {
      throw new runtime.RequiredError(
        "invoiceIdentifier",
        'Required parameter "invoiceIdentifier" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["carrierAccountNumber"] == null) {
      throw new runtime.RequiredError(
        "carrierAccountNumber",
        'Required parameter "carrierAccountNumber" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["amount"] == null) {
      throw new runtime.RequiredError(
        "amount",
        'Required parameter "amount" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["currency"] == null) {
      throw new runtime.RequiredError(
        "currency",
        'Required parameter "currency" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["isAdditional"] == null) {
      throw new runtime.RequiredError(
        "isAdditional",
        'Required parameter "isAdditional" was null or undefined when calling addCarrierInvoice().',
      );
    }

    if (requestParameters["body"] == null) {
      throw new runtime.RequiredError(
        "body",
        'Required parameter "body" was null or undefined when calling addCarrierInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    if (requestParameters["invoiceIdentifier"] != null) {
      queryParameters["invoiceIdentifier"] =
        requestParameters["invoiceIdentifier"];
    }

    if (requestParameters["carrierAccountNumber"] != null) {
      queryParameters["carrierAccountNumber"] =
        requestParameters["carrierAccountNumber"];
    }

    if (requestParameters["amount"] != null) {
      queryParameters["amount"] = requestParameters["amount"];
    }

    if (requestParameters["currency"] != null) {
      queryParameters["currency"] = requestParameters["currency"];
    }

    if (requestParameters["isAdditional"] != null) {
      queryParameters["isAdditional"] = requestParameters["isAdditional"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/pdf";

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/add-carrier-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters["body"] as any,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierInvoiceApprovalTypeFromJSON(jsonValue),
    );
  }

  /**
   */
  async addCarrierInvoice(
    requestParameters: AddCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierInvoiceApprovalType> {
    const response = await this.addCarrierInvoiceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async checkIfCarrierCreditNoteIsPaidRaw(
    requestParameters: CheckIfCarrierCreditNoteIsPaidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierCreditNoteId"] == null) {
      throw new runtime.RequiredError(
        "carrierCreditNoteId",
        'Required parameter "carrierCreditNoteId" was null or undefined when calling checkIfCarrierCreditNoteIsPaid().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierCreditNoteId"] != null) {
      queryParameters["carrierCreditNoteId"] =
        requestParameters["carrierCreditNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/check-if-carrier-credit-note-is-paid`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async checkIfCarrierCreditNoteIsPaid(
    requestParameters: CheckIfCarrierCreditNoteIsPaidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.checkIfCarrierCreditNoteIsPaidRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async checkIfCarrierInvoiceIsPaidRaw(
    requestParameters: CheckIfCarrierInvoiceIsPaidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling checkIfCarrierInvoiceIsPaid().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/check-if-carrier-invoice-is-paid`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async checkIfCarrierInvoiceIsPaid(
    requestParameters: CheckIfCarrierInvoiceIsPaidRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.checkIfCarrierInvoiceIsPaidRaw(requestParameters, initOverrides);
  }

  /**
   */
  async checkIfInvoicesArePaidRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/check-if-invoices-are-paid`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async checkIfInvoicesArePaid(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.checkIfInvoicesArePaidRaw(initOverrides);
  }

  /**
   */
  async clearChequeSendAttemptedRaw(
    requestParameters: ClearChequeSendAttemptedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling clearChequeSendAttempted().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/clear-cheque-send-attempted`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async clearChequeSendAttempted(
    requestParameters: ClearChequeSendAttemptedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.clearChequeSendAttemptedRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createCarrierCreditNoteRaw(
    requestParameters: CreateCarrierCreditNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling createCarrierCreditNote().',
      );
    }

    if (requestParameters["amount"] == null) {
      throw new runtime.RequiredError(
        "amount",
        'Required parameter "amount" was null or undefined when calling createCarrierCreditNote().',
      );
    }

    if (requestParameters["currency"] == null) {
      throw new runtime.RequiredError(
        "currency",
        'Required parameter "currency" was null or undefined when calling createCarrierCreditNote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["amount"] != null) {
      queryParameters["amount"] = requestParameters["amount"];
    }

    if (requestParameters["currency"] != null) {
      queryParameters["currency"] = requestParameters["currency"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/create-carrier-credit-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createCarrierCreditNote(
    requestParameters: CreateCarrierCreditNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createCarrierCreditNoteRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createMissingInvoiceMondayAndEmailCarrierRaw(
    requestParameters: CreateMissingInvoiceMondayAndEmailCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling createMissingInvoiceMondayAndEmailCarrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/create-missing-invoice-monday-and-email-carrier`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createMissingInvoiceMondayAndEmailCarrier(
    requestParameters: CreateMissingInvoiceMondayAndEmailCarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createMissingInvoiceMondayAndEmailCarrierRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async createProvisionalInvoiceRaw(
    requestParameters: CreateProvisionalInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling createProvisionalInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/create-provisional-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createProvisionalInvoice(
    requestParameters: CreateProvisionalInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createProvisionalInvoiceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async createXeroCarrierInvoiceRaw(
    requestParameters: CreateXeroCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling createXeroCarrierInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/create-xero-carrier-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async createXeroCarrierInvoice(
    requestParameters: CreateXeroCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.createXeroCarrierInvoiceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async getCarrierInvoiceByChequeNumberRaw(
    requestParameters: GetCarrierInvoiceByChequeNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierInvoice>> {
    if (requestParameters["chequeNumber"] == null) {
      throw new runtime.RequiredError(
        "chequeNumber",
        'Required parameter "chequeNumber" was null or undefined when calling getCarrierInvoiceByChequeNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["chequeNumber"] != null) {
      queryParameters["chequeNumber"] = requestParameters["chequeNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/get-carrier-invoice-by-cheque-number`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierInvoiceFromJSON(jsonValue),
    );
  }

  /**
   */
  async getCarrierInvoiceByChequeNumber(
    requestParameters: GetCarrierInvoiceByChequeNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierInvoice> {
    const response = await this.getCarrierInvoiceByChequeNumberRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierRequestAuditForQuoteRaw(
    requestParameters: GetCarrierRequestAuditForQuoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierRequestAudit>>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierRequestAuditForQuote().',
      );
    }

    if (requestParameters["quoteId"] == null) {
      throw new runtime.RequiredError(
        "quoteId",
        'Required parameter "quoteId" was null or undefined when calling getCarrierRequestAuditForQuote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    if (requestParameters["quoteId"] != null) {
      queryParameters["quoteId"] = requestParameters["quoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/get-carrier-request-audit-for-quote`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierRequestAuditFromJSON),
    );
  }

  /**
   */
  async getCarrierRequestAuditForQuote(
    requestParameters: GetCarrierRequestAuditForQuoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierRequestAudit>> {
    const response = await this.getCarrierRequestAuditForQuoteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierRequestAuditForSelectedQuoteRaw(
    requestParameters: GetCarrierRequestAuditForSelectedQuoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierRequestAudit>>> {
    if (requestParameters["shipmentId"] == null) {
      throw new runtime.RequiredError(
        "shipmentId",
        'Required parameter "shipmentId" was null or undefined when calling getCarrierRequestAuditForSelectedQuote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["shipmentId"] != null) {
      queryParameters["shipmentId"] = requestParameters["shipmentId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/get-carrier-request-audit-for-selected-quote`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierRequestAuditFromJSON),
    );
  }

  /**
   */
  async getCarrierRequestAuditForSelectedQuote(
    requestParameters: GetCarrierRequestAuditForSelectedQuoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierRequestAudit>> {
    const response = await this.getCarrierRequestAuditForSelectedQuoteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getPaymentPropertiesRaw(
    requestParameters: GetPaymentPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierPaymentProperties>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling getPaymentProperties().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/get-payment-properties`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierPaymentPropertiesFromJSON(jsonValue),
    );
  }

  /**
   */
  async getPaymentProperties(
    requestParameters: GetPaymentPropertiesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierPaymentProperties> {
    const response = await this.getPaymentPropertiesRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getShipmentsOverdueInvoicesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MissingInvoicesScreenRecords>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/shipments-overdue-invoices`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MissingInvoicesScreenRecordsFromJSON(jsonValue),
    );
  }

  /**
   */
  async getShipmentsOverdueInvoices(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MissingInvoicesScreenRecords> {
    const response = await this.getShipmentsOverdueInvoicesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async markCarrierCreditNoteRefundRequestedRaw(
    requestParameters: MarkCarrierCreditNoteRefundRequestedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierCreditNoteId"] == null) {
      throw new runtime.RequiredError(
        "carrierCreditNoteId",
        'Required parameter "carrierCreditNoteId" was null or undefined when calling markCarrierCreditNoteRefundRequested().',
      );
    }

    if (requestParameters["refundRequested"] == null) {
      throw new runtime.RequiredError(
        "refundRequested",
        'Required parameter "refundRequested" was null or undefined when calling markCarrierCreditNoteRefundRequested().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierCreditNoteId"] != null) {
      queryParameters["carrierCreditNoteId"] =
        requestParameters["carrierCreditNoteId"];
    }

    if (requestParameters["refundRequested"] != null) {
      queryParameters["refundRequested"] = requestParameters["refundRequested"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-carrier-credit-note-refund-requested`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markCarrierCreditNoteRefundRequested(
    requestParameters: MarkCarrierCreditNoteRefundRequestedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markCarrierCreditNoteRefundRequestedRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markCarrierInvoiceApprovedRaw(
    requestParameters: MarkCarrierInvoiceApprovedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markCarrierInvoiceApproved().',
      );
    }

    if (requestParameters["approvalReason"] == null) {
      throw new runtime.RequiredError(
        "approvalReason",
        'Required parameter "approvalReason" was null or undefined when calling markCarrierInvoiceApproved().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["approvalReason"] != null) {
      queryParameters["approvalReason"] = requestParameters["approvalReason"];
    }

    if (requestParameters["cancelledShipmentApprovalReason"] != null) {
      queryParameters["cancelledShipmentApprovalReason"] =
        requestParameters["cancelledShipmentApprovalReason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-carrier-invoice-approved`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markCarrierInvoiceApproved(
    requestParameters: MarkCarrierInvoiceApprovedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markCarrierInvoiceApprovedRaw(requestParameters, initOverrides);
  }

  /**
   */
  async markCarrierInvoicePaymentPendingRaw(
    requestParameters: MarkCarrierInvoicePaymentPendingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markCarrierInvoicePaymentPending().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-carrier-invoice-payment-pending`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markCarrierInvoicePaymentPending(
    requestParameters: MarkCarrierInvoicePaymentPendingRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markCarrierInvoicePaymentPendingRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markCarrierInvoiceProblemsIdentifiedRaw(
    requestParameters: MarkCarrierInvoiceProblemsIdentifiedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markCarrierInvoiceProblemsIdentified().',
      );
    }

    if (requestParameters["problemsIdentified"] == null) {
      throw new runtime.RequiredError(
        "problemsIdentified",
        'Required parameter "problemsIdentified" was null or undefined when calling markCarrierInvoiceProblemsIdentified().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["problemsIdentified"] != null) {
      queryParameters["problemsIdentified"] =
        requestParameters["problemsIdentified"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-carrier-invoice-problems-identified`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markCarrierInvoiceProblemsIdentified(
    requestParameters: MarkCarrierInvoiceProblemsIdentifiedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markCarrierInvoiceProblemsIdentifiedRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markCarrierInvoiceVoidedRaw(
    requestParameters: MarkCarrierInvoiceVoidedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markCarrierInvoiceVoided().',
      );
    }

    if (requestParameters["voidReason"] == null) {
      throw new runtime.RequiredError(
        "voidReason",
        'Required parameter "voidReason" was null or undefined when calling markCarrierInvoiceVoided().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["voidReason"] != null) {
      queryParameters["voidReason"] = requestParameters["voidReason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-carrier-invoice-voided`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markCarrierInvoiceVoided(
    requestParameters: MarkCarrierInvoiceVoidedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markCarrierInvoiceVoidedRaw(requestParameters, initOverrides);
  }

  /**
   */
  async markPaymentConfirmedCarrierInvoiceVoidedRaw(
    requestParameters: MarkPaymentConfirmedCarrierInvoiceVoidedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markPaymentConfirmedCarrierInvoiceVoided().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling markPaymentConfirmedCarrierInvoiceVoided().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-payment-confirmed-carrier-invoice-voided`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markPaymentConfirmedCarrierInvoiceVoided(
    requestParameters: MarkPaymentConfirmedCarrierInvoiceVoidedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markPaymentConfirmedCarrierInvoiceVoidedRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async markPaymentPendingCarrierInvoiceApprovedRaw(
    requestParameters: MarkPaymentPendingCarrierInvoiceApprovedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling markPaymentPendingCarrierInvoiceApproved().',
      );
    }

    if (requestParameters["reason"] == null) {
      throw new runtime.RequiredError(
        "reason",
        'Required parameter "reason" was null or undefined when calling markPaymentPendingCarrierInvoiceApproved().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["reason"] != null) {
      queryParameters["reason"] = requestParameters["reason"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/mark-payment-pending-carrier-invoice-approved`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async markPaymentPendingCarrierInvoiceApproved(
    requestParameters: MarkPaymentPendingCarrierInvoiceApprovedRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.markPaymentPendingCarrierInvoiceApprovedRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async payCarrierInvoiceByChequeRaw(
    requestParameters: PayCarrierInvoiceByChequeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling payCarrierInvoiceByCheque().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/pay-carrier-invoice-by-cheque`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async payCarrierInvoiceByCheque(
    requestParameters: PayCarrierInvoiceByChequeRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.payCarrierInvoiceByChequeRaw(requestParameters, initOverrides);
  }

  /**
   */
  async previewEmailForCarrierInvoiceRaw(
    requestParameters: PreviewEmailForCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EmailDescription>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling previewEmailForCarrierInvoice().',
      );
    }

    if (requestParameters["invoiceChallengeType"] == null) {
      throw new runtime.RequiredError(
        "invoiceChallengeType",
        'Required parameter "invoiceChallengeType" was null or undefined when calling previewEmailForCarrierInvoice().',
      );
    }

    if (requestParameters["extraText"] == null) {
      throw new runtime.RequiredError(
        "extraText",
        'Required parameter "extraText" was null or undefined when calling previewEmailForCarrierInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["invoiceChallengeType"] != null) {
      queryParameters["invoiceChallengeType"] =
        requestParameters["invoiceChallengeType"];
    }

    if (requestParameters["extraText"] != null) {
      queryParameters["extraText"] = requestParameters["extraText"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/preview-email-for-carrier-invoice`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EmailDescriptionFromJSON(jsonValue),
    );
  }

  /**
   */
  async previewEmailForCarrierInvoice(
    requestParameters: PreviewEmailForCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EmailDescription> {
    const response = await this.previewEmailForCarrierInvoiceRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async previewEmailForOverchargeClaimRaw(
    requestParameters: PreviewEmailForOverchargeClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<EmailDescription>> {
    if (requestParameters["carrierCreditNoteId"] == null) {
      throw new runtime.RequiredError(
        "carrierCreditNoteId",
        'Required parameter "carrierCreditNoteId" was null or undefined when calling previewEmailForOverchargeClaim().',
      );
    }

    if (requestParameters["extraText"] == null) {
      throw new runtime.RequiredError(
        "extraText",
        'Required parameter "extraText" was null or undefined when calling previewEmailForOverchargeClaim().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierCreditNoteId"] != null) {
      queryParameters["carrierCreditNoteId"] =
        requestParameters["carrierCreditNoteId"];
    }

    if (requestParameters["extraText"] != null) {
      queryParameters["extraText"] = requestParameters["extraText"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/preview-email-for-overcharge-claim`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      EmailDescriptionFromJSON(jsonValue),
    );
  }

  /**
   */
  async previewEmailForOverchargeClaim(
    requestParameters: PreviewEmailForOverchargeClaimRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<EmailDescription> {
    const response = await this.previewEmailForOverchargeClaimRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async requestPayCarrierInvoiceRaw(
    requestParameters: RequestPayCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling requestPayCarrierInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/request-pay-carrier-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async requestPayCarrierInvoice(
    requestParameters: RequestPayCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.requestPayCarrierInvoiceRaw(requestParameters, initOverrides);
  }

  /**
   */
  async sendEmailAskingToChargeCardOnFileForCarrierInvoiceRaw(
    requestParameters: SendEmailAskingToChargeCardOnFileForCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling sendEmailAskingToChargeCardOnFileForCarrierInvoice().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/send-email-asking-to-charge-card-on-file-for-carrier-invoice`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendEmailAskingToChargeCardOnFileForCarrierInvoice(
    requestParameters: SendEmailAskingToChargeCardOnFileForCarrierInvoiceRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.sendEmailAskingToChargeCardOnFileForCarrierInvoiceRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async sendOverchargeClaimEmailRaw(
    requestParameters: SendOverchargeClaimEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierCreditNoteId"] == null) {
      throw new runtime.RequiredError(
        "carrierCreditNoteId",
        'Required parameter "carrierCreditNoteId" was null or undefined when calling sendOverchargeClaimEmail().',
      );
    }

    if (requestParameters["extraText"] == null) {
      throw new runtime.RequiredError(
        "extraText",
        'Required parameter "extraText" was null or undefined when calling sendOverchargeClaimEmail().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierCreditNoteId"] != null) {
      queryParameters["carrierCreditNoteId"] =
        requestParameters["carrierCreditNoteId"];
    }

    if (requestParameters["extraText"] != null) {
      queryParameters["extraText"] = requestParameters["extraText"];
    }

    if (requestParameters["toAddresses"] != null) {
      queryParameters["toAddresses"] = requestParameters["toAddresses"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    if (requestParameters["ccEmail"] != null) {
      queryParameters["ccEmail"] = requestParameters["ccEmail"]!.join(
        runtime.COLLECTION_FORMATS["csv"],
      );
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/send-overcharge-claim-email`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async sendOverchargeClaimEmail(
    requestParameters: SendOverchargeClaimEmailRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.sendOverchargeClaimEmailRaw(requestParameters, initOverrides);
  }

  /**
   */
  async setCarrierXeroInvoiceIdRaw(
    requestParameters: SetCarrierXeroInvoiceIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling setCarrierXeroInvoiceId().',
      );
    }

    if (requestParameters["xeroInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "xeroInvoiceId",
        'Required parameter "xeroInvoiceId" was null or undefined when calling setCarrierXeroInvoiceId().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["xeroInvoiceId"] != null) {
      queryParameters["xeroInvoiceId"] = requestParameters["xeroInvoiceId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/set-carrier-xero-invoice-id`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async setCarrierXeroInvoiceId(
    requestParameters: SetCarrierXeroInvoiceIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.setCarrierXeroInvoiceIdRaw(requestParameters, initOverrides);
  }

  /**
   */
  async updateCarrierInvoiceCarrierAccountNumberRaw(
    requestParameters: UpdateCarrierInvoiceCarrierAccountNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling updateCarrierInvoiceCarrierAccountNumber().',
      );
    }

    if (requestParameters["carrierAccountNumber"] == null) {
      throw new runtime.RequiredError(
        "carrierAccountNumber",
        'Required parameter "carrierAccountNumber" was null or undefined when calling updateCarrierInvoiceCarrierAccountNumber().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["carrierAccountNumber"] != null) {
      queryParameters["carrierAccountNumber"] =
        requestParameters["carrierAccountNumber"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/update-carrier-invoice-carrier-account-number`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateCarrierInvoiceCarrierAccountNumber(
    requestParameters: UpdateCarrierInvoiceCarrierAccountNumberRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCarrierInvoiceCarrierAccountNumberRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async updateCarrierInvoiceInvoiceIdentifierRaw(
    requestParameters: UpdateCarrierInvoiceInvoiceIdentifierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierInvoiceId"] == null) {
      throw new runtime.RequiredError(
        "carrierInvoiceId",
        'Required parameter "carrierInvoiceId" was null or undefined when calling updateCarrierInvoiceInvoiceIdentifier().',
      );
    }

    if (requestParameters["invoiceIdentifier"] == null) {
      throw new runtime.RequiredError(
        "invoiceIdentifier",
        'Required parameter "invoiceIdentifier" was null or undefined when calling updateCarrierInvoiceInvoiceIdentifier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierInvoiceId"] != null) {
      queryParameters["carrierInvoiceId"] =
        requestParameters["carrierInvoiceId"];
    }

    if (requestParameters["invoiceIdentifier"] != null) {
      queryParameters["invoiceIdentifier"] =
        requestParameters["invoiceIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/update-carrier-invoice-invoice-identifier`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async updateCarrierInvoiceInvoiceIdentifier(
    requestParameters: UpdateCarrierInvoiceInvoiceIdentifierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.updateCarrierInvoiceInvoiceIdentifierRaw(
      requestParameters,
      initOverrides,
    );
  }

  /**
   */
  async viewCarrierCreditNotesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierCreditNote>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/view-carrier-credit-notes`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierCreditNoteFromJSON),
    );
  }

  /**
   */
  async viewCarrierCreditNotes(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierCreditNote>> {
    const response = await this.viewCarrierCreditNotesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async viewCarrierInvoicesRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierInvoiceData>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/view-carrier-invoices`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierInvoiceDataFromJSON(jsonValue),
    );
  }

  /**
   */
  async viewCarrierInvoices(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierInvoiceData> {
    const response = await this.viewCarrierInvoicesRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async voidCarrierCreditNoteRaw(
    requestParameters: VoidCarrierCreditNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["carrierCreditNoteId"] == null) {
      throw new runtime.RequiredError(
        "carrierCreditNoteId",
        'Required parameter "carrierCreditNoteId" was null or undefined when calling voidCarrierCreditNote().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierCreditNoteId"] != null) {
      queryParameters["carrierCreditNoteId"] =
        requestParameters["carrierCreditNoteId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-invoice/void-carrier-credit-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async voidCarrierCreditNote(
    requestParameters: VoidCarrierCreditNoteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.voidCarrierCreditNoteRaw(requestParameters, initOverrides);
  }
}
